<template>
    <div id="home-frame">
        <header class="columns">
            <div class="column is-3">
                <h1>
                    <span @click="$resetCards()"><strong>my</strong>247ed.com</span>
                </h1>
            </div>
            <div class="column menu has-text-right">
                <div class="pb-3">
                    <b-dropdown aria-role="list" v-if="currentUser.isSuper">
                        <template #trigger="{ active }">
                            <span class="is-clickable has-text-weight-normal">
                                <i class="fad fa-building-user mr-2"></i>{{ currentUser.orgTitle }}<i class="fas ml-3 mr-5" :class="active ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </span>
                        </template>

                        <b-dropdown-item
                            aria-role="listitem"
                            v-for="o in organizations"
                            class="has-text-black has-text-weight-normal has-text-left"
                            @click="switchOrg(o.id);"
                        >
                            {{ o.title }}
                        </b-dropdown-item>
                    </b-dropdown>
                    <span v-else class="mr-5">
                        <i class="fad fa-building-user mr-2"></i>{{ currentUser.orgTitle }}
                        <b-tooltip v-if="currentUser.contentProviderId" :label="currentUser.contentProviderTitle" position="is-left">
                            <b-tag class="ml-4"><i class="fad fa-person-chalkboard has-text-primary ml-0"></i></b-tag>
                        </b-tooltip>
                    </span>

                    <span v-if="currentUser">{{ currentUser.firstName }} {{ currentUser.lastName }}</span>
                    <a v-if="currentUser" @click="$openCard('user-settings')">
                        <b-tooltip label="User Settings" position="is-bottom" class="ml-3">
                            <b-icon pack="fad" icon="user-cog" />
                        </b-tooltip>
                    </a>

                    <a @click="logout">
                        <b-tooltip label="Logout" position="is-bottom" class="ml-3">
                            <b-icon pack="fad" icon="sign-out-alt" />
                        </b-tooltip>
                    </a>
                </div>
            </div>
        </header>

        <main v-if="currentUser">
            <div class="start fadeIn content" v-show="$TIER.cards.length === 0">
                <div class="welcome">
                    <h1><strong>{{ welcome }},</strong> {{ currentUser.firstName }}</h1>
                    <h3>What would you like to do?</h3>
                </div>
                <div class="columns">
                    <div class="column" :class="currentUser.isSuper ? 'is-8' : 'is-12'">
                        <div class="menu">
                            <div class="items">
                                <div class="menu-item" @click="$openCard('users')" v-if="allowed('users-list')">
                                    <i class="fad fa-users"></i>
                                    <span class="menu-title">Users</span>
                                </div>
                                <div class="menu-item" @click="$openCard('support-list')" v-if="allowed('support-list')">
                                    <i class="fad fa-user-headset"></i>
                                    <span class="menu-title">Support</span>
                                    <!--                                <span class="menu-tag">3</span>-->
                                </div>
                                <div class="menu-item" @click="$openCard('reviews')" v-if="allowed('review')">
                                    <i class="fad fa-file-signature ml-4"></i>
                                    <span class="menu-title">Review</span>
                                    <span class="menu-tag" v-if="reviewsBadge > 0">{{ reviewsBadge }}</span>
                                </div>
                                <div class="menu-item" @click="$openCard('billing-menu')" v-if="allowed('billing-menu')">
                                    <i class="fad fa-money-check"></i>
                                    <span class="menu-title">Billing</span>
                                </div>
                                <div class="menu-item" @click="$openCard('payment-plans')" v-if="allowed('payment-plans-menu')">
                                    <i class="fad fa-money-check-alt"></i>
                                    <span class="menu-title">Payment Plans</span>
                                    <span class="menu-tag" v-if="plansBadge" v-html="plansBadge"></span>
                                </div>
                                <div class="menu-item" @click="$openCard('transactions-menu')" v-if="currentUser.isSuper">
                                    <i class="fad fa-usd-circle"></i>
                                    <span class="menu-title">Transactions</span>
                                </div>
                                <div class="menu-item" @click="$openCard('sales-tax-menu')" v-if="allowed('sales-tax-menu')">
                                    <i class="fad fa-university"></i>
                                    <span class="menu-title">Sales Tax</span>
                                </div>
                                <div class="menu-item" @click="$openCard('plans-list', {type: 'collections'})" v-if="allowed('collections')">
                                    <i class="fad fa-gavel"></i>
                                    <span class="menu-title">Collections</span>
                                </div>
                                <div class="menu-item" @click="$openCard('quotes')" v-if="allowed('quotes')">
                                    <i class="fad fa-file-signature"></i>
                                    <span class="menu-title">Reseller Quotes</span>
                                </div>
                                <div class="menu-item" @click="$openCard('reseller-enroll-report', {userId: 0})" v-if="allowed('reseller-enroll-report')">
                                    <i class="fad fa-clipboard-check"></i>
                                    <span class="menu-title">Enrollments</span>
                                </div>
                                <div class="menu-item" @click="$openCard('reseller-client-database')" v-if="allowed('reseller-client-database')">
                                    <i class="fad fa-users"></i>
                                    <span class="menu-title">Clients</span>
                                </div>
                                <div class="menu-item" @click="$openCard('reseller-quotes')" v-if="allowed('reseller-quotes')">
                                    <i class="fad fa-file-invoice-dollar"></i>
                                    <span class="menu-title">Quotes</span>
                                </div>
                                <div class="menu-item" @click="$openCard('reseller-pending-plans')" v-if="allowed('reseller-pending-plans')">
                                    <i class="fad fa-timer"></i>
                                    <span class="menu-title">Pending Plans</span>
                                </div>
                                <div class="menu-item" @click="$openCard('resellers')" v-if="allowed('resellers')">
                                    <i class="fad fa-user-tie"></i>
                                    <span class="menu-title">Resellers</span>
                                </div>


                                <div class="menu-item" @click="$openCard('courses')" v-if="allowed('course-menu-list')">
                                    <i class="fad fa-chalkboard-teacher"></i>
                                    <span class="menu-title">Courses</span>
                                </div>
                                <!--                            <div class="menu-item" @click="$openCard('components')" v-if="allowed('course-menu-list')">-->
                                <!--                                <i class="fad fa-cubes"></i>-->
                                <!--                                <span class="menu-title">Components</span>-->
                                <!--                            </div>-->

                                <div class="menu-item" @click="$openCard('conferences')" v-if="allowed('conferences')">
                                    <i class="fad fa-users-class"></i>
                                    <span class="menu-title">Conferences</span>
                                </div>
                                <div class="menu-item" @click="$openCard('applications')" v-if="allowed('course-menu-list')">
                                    <i class="fad fa-file-certificate"></i>
                                    <span class="menu-title">Applications</span>
                                </div>
                                <div class="menu-item" @click="$openCard('certifications')" v-if="(currentUser.isAdmin || currentUser.isSuper) && allowed('course-menu-list')">
                                    <i class="far fa-certificate"></i>
                                    <span class="menu-title">Certifications</span>
                                </div>
                                <div class="menu-item" @click="$openCard('wiaa-certification-lookup')" v-if="allowed('wiaa-certification-lookup')">
                                    <i class="fad fa-search-plus"></i>
                                    <span class="menu-title">WIAA Lookup</span>
                                </div>
                                <div class="menu-item" @click="$openCard('media-library')" v-if="allowed('course-menu-list')">
                                    <i class="fad fa-photo-film-music"></i>
                                    <span class="menu-title">Media Library</span>
                                </div>
                                <!--                            <div class="menu-item" @click="$openCard('settings-list')" v-if="allowed('settings-list')">-->
                                <!--                                <i class="fad fa-cogs ml-2"></i>-->
                                <!--                                <span class="menu-title">Settings</span>-->
                                <!--                            </div>-->
                                <div class="menu-item" @click="$openCard('approval')" v-if="currentUser.isApprovalCommittee && allowed('approval')">
                                    <i class="fad fa-memo-circle-check"></i>
                                    <span class="menu-title">Approvals</span>
                                </div>
                                <div class="menu-item" @click="$openCard('activity')" v-if="allowed('information')">
                                    <i class="fad fa-users-viewfinder"></i>
                                    <span class="menu-title">Activity</span>
                                </div>
                                <div class="menu-item" @click="$openCard('tools')" v-if="allowed('tools')">
                                    <i class="fad fa-tools"></i>
                                    <span class="menu-title">Tools</span>
                                </div>
                                <div class="menu-item" @click="$openCard('reports')" v-if="allowed('reports')">
                                    <i class="fad fa-chart-line"></i>
                                    <span class="menu-title">Reports</span>
                                </div>
                                <!--                            <div class="menu-item" @click="$openCard('tpo')" v-if="allowed('tpo')">-->
                                <!--                                <i class="fad fa-credit-card"></i>-->
                                <!--                                <span class="menu-title">TPO</span>-->
                                <!--                            </div>-->
                                <div class="menu-item" @click="$openCard('org-settings')" v-if="(currentUser.isAdmin || currentUser.isSuper) && allowed('org-settings')">
                                    <i class="fad fa-building-user"></i>
                                    <span class="menu-title">Organization</span>
                                </div>
                                <div class="menu-item" @click="$openCard('content-providers')" v-if="(currentUser.isAdmin || currentUser.isSuper) && allowed('content-providers')">
                                    <i class="fad fa-person-chalkboard"></i>
                                    <span class="menu-title">Providers</span>
                                </div>
                                <div class="menu-item" @click="$openCard('user-settings')" v-if="allowed('user-settings')">
                                    <i class="fad fa-user-cog"></i>
                                    <span class="menu-title">User Settings</span>
                                </div>
                                <div class="menu-item" @click="logout" v-if="allowed('logout')">
                                    <i class="fad fa-sign-out"></i>
                                    <span class="menu-title">Logout</span>
                                </div>
                            </div>

                        </div>
                        <div class="mt-6" v-if="allowed('users-list')">
                            <div class="columns">
                                <div class="column is-6">
                                    <b-input icon="user-magnifying-glass" v-model="userSearch" @keyup.enter="searchUser" @keyup.native.enter="searchUser" placeholder="Search User..."></b-input>
                                </div>
                            </div>
                        </div>
                        <div class="sub-menu">
                            <div class="menu-item" @click="$openCard('new-reseller-quote')" v-if="allowed('reseller-quotes')">
                                <i class="far fa-plus"></i>
                                <span>New Quote</span>
                            </div>
                            <div class="menu-item" @click="openUrl('https://app.thepaymentoption.com/api/scripts/stats')" v-if="allowed('tpo')">
                                <i class="fad fa-money-bill-trend-up"></i>
                                <span>TPO Stats</span>
                            </div>
                            <!--                            <div class="menu-item" @click="openUrl((location.hostname === 'staging.my247ed.com') ? 'https://staging-api.my247ed.com/scripts/wiaa' : 'https://api.my247ed.com/scripts/wiaa')" v-if="allowed('tpo')">-->
                            <!--                                <i class="fad fa-bars-progress"></i>-->
                            <!--                                <span>WIAA Stats</span>-->
                            <!--                            </div>-->
                            <!--                            <div class="menu-item" @click="openUrl((location.hostname === 'staging.my247ed.com') ? 'https://staging-api.my247ed.com/scripts/coachup' : 'https://api.my247ed.com/scripts/coachup')" v-if="allowed('tpo')">-->
                            <!--                                <i class="fad fa-bars-progress"></i>-->
                            <!--                                <span>CoachUp</span>-->
                            <!--                            </div>-->
                            <div class="menu-item" @click="openUrl('https://dashboard.stripe.com/')" v-if="allowed('tpo')">
                                <i class="fad fa-credit-card"></i>
                                <span>Stripe</span>
                            </div>
                            <div class="menu-item" @click="openUrl('https://app.staxpayments.com/')" v-if="allowed('tpo')">
                                <i class="fad fa-money-check"></i>
                                <span>Stax</span>
                            </div>
                            <div class="menu-item" @click="openUrl('https://www.convergepay.com/converge-webapp/#!/login')" v-if="allowed('tpo')">
                                <i class="fad fa-square-dollar"></i>
                                <span>Converge</span>
                            </div>
                            <!--                            <div class="menu-item" @click="$openCard('test')" v-if="allowed('tpo')">-->
                            <!--                                <i class="fad fa-cog"></i>-->
                            <!--                                <span>Test</span>-->
                            <!--                            </div>-->
                            <div class="menu-item" @click="openUrl('https://apps.docusign.com/send/home')" v-if="allowed('tpo')">
                                <i class="fad fa-signature"></i>
                                <span>Docusign</span>
                            </div>
                            <div class="menu-item" @click="openUrl('https://app.mailgun.com/')" v-if="allowed('tpo')">
                                <i class="fad fa-mail-bulk"></i>
                                <span>Mailgun</span>
                            </div>
                            <div class="menu-item" @click="openUrl('https://dashboard.clicksend.com/home')" v-if="allowed('tpo')">
                                <i class="fad fa-message-sms"></i>
                                <span>Clicksend</span>
                            </div>
                            <div class="menu-item" @click="openUrl('https://dashboard.postgrid.com/')" v-if="allowed('tpo')">
                                <i class="fad fa-envelope"></i>
                                <span>PostGrid</span>
                            </div>
                            <div class="menu-item" @click="openUrl('https://analytics.google.com/analytics/web/#/')" v-if="allowed('tpo')">
                                <i class="fad fa-earth-americas"></i>
                                <span>Analytics</span>
                            </div>
                            <div class="menu-item" @click="openUrl('https://logs.betterstack.com')" v-if="allowed('tpo')">
                                <i class="fad fa-square-terminal"></i>
                                <span>Better Stack</span>
                            </div>
                            <div class="menu-item" @click="openUrl('https://deverlopers.google.com')" v-if="allowed('tpo')">
                                <i class="fa-brands fa-google"></i>
                                <span>Google Dev</span>
                            </div>
                        </div>
                        <div class="menu legacy-menu" v-if="currentUser.isAdmin || currentUser.isSuper">
                            <h3 class="has-text-white">Legacy</h3>

                            <div class="items">
                                <!--                                <div class="menu-item" @click="$openCard('conferences-legacy')" v-if="allowed('conferences-legacy')">-->
                                <!--                                    <i class="fad fa-users-class"></i>-->
                                <!--                                    <span class="menu-title">Confs (Legacy)</span>-->
                                <!--                                </div>-->
                                <div class="menu-item" @click="$openCard('rmc-conferences')" v-if="allowed('rmc-dashboard')">
                                    <img src="../assets/rmc-logo-icon-BLU-WHT.png" width="50" />
                                    <span class="menu-title">RMC</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Admin Stats Widgets -->
                    <div class="column is-4" v-if="currentUser.isSuper">
                        <div class="admin-widgets">
                            <!-- Users Widget -->
                            <div class="stat-widget">
                                <div class="widget-header">
                                    <i class="fad fa-users"></i>
                                    <span class="widget-title">Users</span>
                                </div>
                                <div class="widget-body">
                                    <div class="stat-row">
                                        <span class="stat-label">Signups Today</span>
                                        <span class="stat-value">
                                            {{ dashboardStats.users_signups_today || 0 }}
                                            <span class="trend" :class="trendClass('users_signups')" v-if="showTrend('users_signups')">
                                                <i class="fas" :class="trendIcon('users_signups')"></i>
                                                {{ trendDiff('users_signups') }}
                                            </span>
                                        </span>
                                    </div>
                                    <div class="stat-row">
                                        <span class="stat-label">Logins Today</span>
                                        <span class="stat-value">
                                            {{ dashboardStats.users_logins_today || 0 }}
                                            <span class="trend" :class="trendClass('users_logins')" v-if="showTrend('users_logins')">
                                                <i class="fas" :class="trendIcon('users_logins')"></i>
                                                {{ trendDiff('users_logins') }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Courses Widget -->
                            <div class="stat-widget">
                                <div class="widget-header">
                                    <i class="fad fa-chalkboard-teacher"></i>
                                    <span class="widget-title">Courses</span>
                                </div>
                                <div class="widget-body">
                                    <div class="stat-row">
                                        <span class="stat-label">Enrollments Today</span>
                                        <span class="stat-value">
                                            {{ dashboardStats.courses_enrollments_today || 0 }}
                                            <span class="trend" :class="trendClass('courses_enrollments')" v-if="showTrend('courses_enrollments')">
                                                <i class="fas" :class="trendIcon('courses_enrollments')"></i>
                                                {{ trendDiff('courses_enrollments') }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Conferences Widget -->
                            <div class="stat-widget">
                                <div class="widget-header">
                                    <i class="fad fa-users-class"></i>
                                    <span class="widget-title">Conferences</span>
                                </div>
                                <div class="widget-body">
                                    <div class="stat-row">
                                        <span class="stat-label">Registrations Today</span>
                                        <span class="stat-value">
                                            {{ dashboardStats.conferences_registrations_today || 0 }}
                                            <span class="trend" :class="trendClass('conferences_registrations')" v-if="showTrend('conferences_registrations')">
                                                <i class="fas" :class="trendIcon('conferences_registrations')"></i>
                                                {{ trendDiff('conferences_registrations') }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Payment Plans Widget -->
                            <div class="stat-widget">
                                <div class="widget-header">
                                    <i class="fad fa-money-check-alt"></i>
                                    <span class="widget-title">Payment Plans</span>
                                </div>
                                <div class="widget-body">
                                    <div class="stat-row">
                                        <span class="stat-label">Created This Month</span>
                                        <span class="stat-value">
                                            {{ dashboardStats.payment_plans_this_month || 0 }}
                                            <span class="trend" :class="trendClassMonth('payment_plans')" v-if="showTrendMonth('payment_plans')">
                                                <i class="fas" :class="trendIconMonth('payment_plans')"></i>
                                                {{ trendDiffMonth('payment_plans') }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <stack class="cards" v-show="$TIER.cards.length" />
        </main>

        <footer class="columns is-gapless" v-if="currentUser">
            <div class="column is-10">
                <ul class="mh-breadcrumb" :class="{'active': $TIER.cards.length}">
                    <li @click="$resetCards()"><span><i class="fad fa-home" style="margin-right: 0"></i></span></li>
                    <li v-for="(card, index) in $TIER.cards" :class="{'active': index >= $TIER.activeCard && index < $TIER.activeCard + $TIER.cardCount}" @click="$setActiveCard(index)">
                        <span><i class="fad" :class="card.definition.icon" v-if="card.definition.icon"></i>{{ card.title || card.definition.title || card.definition.component }}</span>
                    </li>
                </ul>
            </div>
            <div class="column has-text-right">
                <span v-if="$TIER.saveAlert.active" class="has-text-warning is-size-7 has-text-weight-bold"><i class="far fa-exclamation-triangle mr-2"></i>Unsaved Changes</span>
                <span v-else class="is-size-7"><strong class="has-text-white">Portal</strong> v{{version}}</span>
            </div>
        </footer>

        <div class="ml-5 pl-5 has-text-white" v-else>Invalid request. Please logout.</div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {allowed} from "@/constants/permissions";
    import Stack from "../TIER/components/Stack";
    import {client as http} from '@/http_client';
    import async from "async";
    import pkg from '../../package.json';

    export default {
        name: 'secure',
        components: {Stack},
        data: function () {
            return {
                organizations: [],
                userSearch: '',
                statusPollTimer: null,
                version: pkg.version
            };
        },
        computed: {
            ...mapGetters(['currentUser', 'reviews', 'paymentPlanCounts', 'dashboardStats']),
            welcome: function () {
                const currentHour = new Date().getHours();
                return currentHour >= 4 && currentHour < 12 ? 'Good morning' :
                    currentHour >= 12 && currentHour <= 17 ? 'Good afternoon' :
                        currentHour > 17 || currentHour < 4 ? 'Good evening' : 'Welcome';
            },
            plansBadge: function () {
                let badge = null;
                if (this.paymentPlanCounts.pendingPlans > 0) {
                    badge = '<i class="fad fa-timer"></i>' + this.paymentPlanCounts.pendingPlans;
                }
                if (this.paymentPlanCounts.pendingSubmit > 0) {
                    badge = (badge)
                        ? badge + '<span class="ml-2 has-text-danger"><i class="fas fa-credit-card"></i>' + this.paymentPlanCounts.pendingSubmit + '</span>'
                        : '<span class="has-text-danger"><i class="fas fa-credit-card"></i>' + this.paymentPlanCounts.pendingSubmit + '</span>';
                }
                return badge;
            },
            reviewsBadge: function () {
                let count = 0;
                if (this.reviews.enroll_applications) count += this.reviews.enroll_applications.length;
                if (this.reviews.reg_applications) count += this.reviews.reg_applications.length;
                if (this.reviews.conf_applications) count += this.reviews.conf_applications.filter(app => app.updated_at).length;
                if (this.reviews.course_applications) count += this.reviews.course_applications.filter(app => app.updated_at).length;
                return count;
            }
        },
        methods: {
            trendDiff: function (metric) {
                const today = this.dashboardStats[`${metric}_today`] || 0;
                const yesterday = this.dashboardStats[`${metric}_yesterday`] || 0;
                const diff = today - yesterday;
                return Math.abs(diff);
            },
            trendIcon: function (metric) {
                const today = this.dashboardStats[`${metric}_today`] || 0;
                const yesterday = this.dashboardStats[`${metric}_yesterday`] || 0;
                if (today > yesterday) return 'fa-arrow-up';
                if (today < yesterday) return 'fa-arrow-down';
                return 'fa-minus';
            },
            trendClass: function (metric) {
                const today = this.dashboardStats[`${metric}_today`] || 0;
                const yesterday = this.dashboardStats[`${metric}_yesterday`] || 0;
                if (today > yesterday) return 'trend-up';
                if (today < yesterday) return 'trend-down';
                return 'trend-neutral';
            },
            showTrend: function (metric) {
                const today = this.dashboardStats[`${metric}_today`];
                const yesterday = this.dashboardStats[`${metric}_yesterday`];
                return today !== undefined && yesterday !== undefined;
            },
            // Monthly trend methods
            trendDiffMonth: function (metric) {
                const thisMonth = this.dashboardStats[`${metric}_this_month`] || 0;
                const lastMonth = this.dashboardStats[`${metric}_last_month`] || 0;
                const diff = thisMonth - lastMonth;
                return Math.abs(diff);
            },
            trendIconMonth: function (metric) {
                const thisMonth = this.dashboardStats[`${metric}_this_month`] || 0;
                const lastMonth = this.dashboardStats[`${metric}_last_month`] || 0;
                if (thisMonth > lastMonth) return 'fa-arrow-up';
                if (thisMonth < lastMonth) return 'fa-arrow-down';
                return 'fa-minus';
            },
            trendClassMonth: function (metric) {
                const thisMonth = this.dashboardStats[`${metric}_this_month`] || 0;
                const lastMonth = this.dashboardStats[`${metric}_last_month`] || 0;
                if (thisMonth > lastMonth) return 'trend-up';
                if (thisMonth < lastMonth) return 'trend-down';
                return 'trend-neutral';
            },
            showTrendMonth: function (metric) {
                const thisMonth = this.dashboardStats[`${metric}_this_month`];
                const lastMonth = this.dashboardStats[`${metric}_last_month`];
                return thisMonth !== undefined && lastMonth !== undefined;
            },
            ...mapActions(['signOut', 'switchOrganization', 'getReviews', 'getPaymentPlanCounts', 'getDashboardStats']),
            loadOrganizations: function () {
                http.get('organizations').then(response => {
                    this.organizations = response.data;
                });
            },
            allowed: function (permission) {
                if (this.currentUser) return allowed(this.currentUser.role, permission);
                return false;
            },
            openUrl(url) {
                window.open(url);
            },
            logout: function () {
                this.signOut();
                this.$router.push({name: 'login'});
            },
            searchUser: function () {
                console.log('searchUser', this.userSearch);
                this.$openCard('user-search', {query: this.userSearch}, this.card);
            },
            startTimer: function () {
                this.statusPollTimer = setInterval(() => {
                    this.getReviews();
                    this.getPaymentPlanCounts();
                    this.getDashboardStats();
                }, 300000); // Poll every 5 minutes
            },
            switchOrg: function (id) {
                this.$resetCards();
                this.switchOrganization(id).then(() => {
                    this.getReviews();
                });
            }
        },
        mounted() {
            if (!this.currentUser) this.logout();
            if (this.currentUser.isSuper) this.loadOrganizations();

            this.getReviews();
            this.getPaymentPlanCounts();
            this.getDashboardStats();
            this.startTimer();
        },
        destroyed() {
            clearInterval(this.statusPollTimer);
        }
    };
</script>

<style lang="scss">

    #home-frame {

        display: flex;
        flex-direction: column;
        min-height: 100vh;
        overflow: hidden;

        background: #224C74 radial-gradient(#336699, #1e385c);

        > header {
            padding: 1.5rem 6rem 1rem;
            margin-bottom: 0;
            color: rgba(255, 255, 255, 0.7);

            h1 {
                font-weight: 400;
                font-size: 28px;
                margin-top: 1.5rem;
                display: inline-block;
                cursor: pointer;

                strong {
                    color: rgb(255, 255, 255);
                }
            }

            .menu {
                margin-top: 2rem;
                color: rgb(255, 255, 255);
                font-weight: bold;

                i {
                    margin-left: 1rem;
                    cursor: pointer;

                    &:hover {
                        color: white;
                    }
                }

                a {
                    color: white;
                }
            }

            @media (max-width: 600px) {
                display: none;
            }
        }

        main {
            position: relative;
            flex-grow: 1;

            .start {
                display: flex;
                justify-content: center;
                flex-direction: column;

                transition-delay: 0ms;
                transition-duration: 500ms;

                margin-top: 2rem;
                padding-left: 6rem;
                padding-right: 6rem;
            }

            .welcome {
                color: white;
                padding: 0;
                margin-bottom: 3rem;

                h1 {
                    font-size: 2.5rem;
                    color: #ffffff;

                    strong {
                        color: #ffffff;
                    }
                }

                h3 {
                    font-size: 22px;
                    color: rgba(255, 255, 255, 0.8);
                }

                @media (max-width: 600px) {
                    padding: 1rem;
                    h1 {
                        font-size: 1.3rem;

                    }
                    h3 {
                        font-size: 1rem;
                    }
                }
            }

            .menu {
                margin-top: 0;

                &.legacy-menu {
                    margin-top: 3rem;
                }

                .items {
                    display: flex;
                    flex-wrap: wrap;
                    /*justify-content: space-between;*/

                    .menu-item {
                        border: 1px solid rgba(255, 255, 255, 0.1);
                        color: white;
                        text-align: center;
                        padding: 1.8rem 0 1rem;
                        margin: 0 1.1rem 1rem 0;
                        border-radius: 1.1rem;
                        position: relative;
                        width: 7.5rem;
                        cursor: pointer;
                        transition: all linear 0.15s;

                        &:hover {
                            background: rgba(255, 255, 255, 0.05);
                            border: 1px solid rgba(255, 255, 255, 1);
                        }

                        i {
                            font-size: 2.4rem;
                        }

                        .menu-title {
                            display: block;
                            padding-top: 0.45rem;
                            font-size: 0.85rem;
                        }

                        .menu-tag {
                            position: absolute;
                            top: -0.5rem;
                            right: -0.5rem;
                            background-color: white;
                            color: #336699;
                            padding: 3px 0.4rem 1px;
                            min-width: 26px;
                            font-size: 12px;
                            font-weight: bold;
                            border-radius: 10px;

                            i {
                                font-size: 12px;
                                margin-right: 4px !important;
                                margin-left: 6px !important;

                                &:first-child {
                                    margin-left: 0 !important;
                                }
                            }
                        }

                        @media (max-width: 600px) {
                            width: 100%;
                            text-align: left;
                            padding: 1rem 2rem;

                            i {
                                font-size: 2rem;
                            }

                            .menu-title {
                                display: inline-block;
                                padding: 0 0 0 2rem;
                                margin: 0;
                                font-size: 1rem;
                            }
                        }

                        @media (max-width: 600px) {
                            margin: 0 1rem 1rem 0;
                            padding: 1rem 2rem 0.5rem 2rem;
                        }
                    }
                }

                @media (max-width: 600px) {
                    margin: 0;
                    padding: 0 0 0 1rem;
                }
            }

            .sub-menu {
                display: flex;
                flex-wrap: wrap;
                margin-top: 1rem;

                .menu-item {
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    color: white;
                    text-align: center;
                    padding: 0.3rem 1.1rem 0.2rem 1.1rem;
                    margin: 1rem 1rem 0 0;
                    border-radius: 1.1rem;
                    position: relative;
                    cursor: pointer;
                    transition: all linear 0.15s;

                    &:hover {
                        background: rgba(255, 255, 255, 0.05);
                        border: 1px solid rgba(255, 255, 255, 1);
                    }

                    i {
                        margin-right: 0.6rem;
                    }

                    .menu-title {
                        font-size: 0.85rem;
                    }

                    .tag {
                        background-color: white;
                        color: #336699;
                        padding: 0.23rem 0.55rem;
                        font-size: 11px;
                        font-weight: bold;
                        border-radius: 10px;
                        margin-left: 0.7rem;
                    }
                }
            }

            .start input {
                border: 1px solid rgba(255, 255, 255, 0.1);

                background: transparent;
                border-radius: 2rem;
                color: white;

                &:focus {
                    border: 1px solid rgba(255, 255, 255, 0.6);
                }
            }

            // Admin Stats Widgets
            .admin-widgets {
                padding: 0;
                margin-top: 0;

                .stat-widget {
                    background: transparent;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 1.1rem;
                    margin-bottom: 1rem;
                    padding: 0.8rem 1rem;
                    color: white;
                    transition: all linear 0.15s;

                    &:hover {
                        background: rgba(255, 255, 255, 0.05);
                        border-color: rgba(255, 255, 255, 1);
                    }

                    .widget-header {
                        display: flex;
                        align-items: center;
                        margin-bottom: 0.6rem;
                        padding-bottom: 0.6rem;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

                        i {
                            font-size: 1.5rem;
                            margin-right: 0.8rem;
                            color: rgba(255, 255, 255, 0.9);
                        }

                        .widget-title {
                            font-size: 1.1rem;
                            font-weight: 600;
                            color: rgba(255, 255, 255, 0.95);
                        }
                    }

                    .widget-body {
                        .stat-row {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0.4rem 0;

                            &:not(:last-child) {
                                border-bottom: 1px solid rgba(255, 255, 255, 0.05);
                            }

                            .stat-label {
                                font-size: 0.9rem;
                                color: rgba(255, 255, 255, 0.7);
                            }

                            .stat-value {
                                font-size: 1.4rem;
                                font-weight: 600;
                                color: white;
                                display: flex;
                                align-items: center;
                                gap: 0.8rem;

                                .trend {
                                    font-size: 0.75rem;
                                    padding: 0.2rem 0.5rem;
                                    border-radius: 0.5rem;
                                    font-weight: 600;
                                    display: flex;
                                    align-items: center;
                                    gap: 0.3rem;

                                    &.trend-up {
                                        background: rgba(72, 187, 120, 0.2);
                                        color: #68D391;

                                        i {
                                            color: #68D391;
                                        }
                                    }

                                    &.trend-down {
                                        background: rgba(252, 129, 129, 0.2);
                                        color: #FC8181;

                                        i {
                                            color: #FC8181;
                                        }
                                    }

                                    &.trend-neutral {
                                        background: rgba(255, 255, 255, 0.1);
                                        color: rgba(255, 255, 255, 0.6);

                                        i {
                                            color: rgba(255, 255, 255, 0.6);
                                        }
                                    }

                                    i {
                                        font-size: 0.7rem;
                                    }
                                }
                            }
                        }
                    }
                }

                @media (max-width: 1024px) {
                    margin-top: 2rem;
                }
            }
        }

        footer {
            color: white;
            padding: 2rem 3rem 1rem;

            .mh-breadcrumb {
                list-style: none;
                margin: 0;
                padding: 0;
                font-size: 0.75rem;

                transition-delay: 0ms;
                transition-duration: 500ms;
                opacity: 0;

                &.active {
                    opacity: 1;
                }

                li {
                    display: inline-block;
                    cursor: pointer;

                    i {
                        margin-right: 0.5rem;
                    }

                    span {
                        display: inline-block;
                        margin-bottom: 3px;
                        border-bottom: 1px solid transparent;
                    }

                    &.active span {
                        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                    }

                    &::after {
                        font-family: "Font Awesome 6 Pro", serif;
                        font-weight: 400;
                        content: "\f054";
                        color: rgba(255, 255, 255, 0.3);
                        font-size: 0.8rem;
                        margin: 0 0.7rem;
                    }

                    &:last-child::after {
                        content: ""
                    }
                }
            }

            @media (max-width: 600px) {
                display: none;
            }
        }
    }

</style>

<style lang="scss">
    #home-frame .warning {
        margin-top: 15px;
        display: inline-block;
        color: white;
        background-color: orange;
        border-radius: 16px;
        padding: 2px 12px 2px 10px;
        font-size: 12px;
        font-weight: bold;

        i {
            margin-right: 6px;
        }
    }

    #home-frame img {
        padding-bottom: 3px;
        padding-top: 3px;
    }

    #home-frame .start .control {
        ::placeholder {
            color: rgba(255, 255, 255, 0.22);
            opacity: 1; /* Firefox */
        }

        .icon {
            padding-left: 1rem;
        }

        .input {
            padding-left: 3rem !important;
        }
    }
</style>
